module.exports = __webpack_public_path__ + "cfa0072f61bb778d7e8798733ea69504.fbx";